export const buttonLabels = {
	cancel: "CANCEL"
}

export const drawerAdd = 'ADD';

export const messagePrompts = {
  successCreateUser: "Successfully created! Reloading page...",
  successUpdateUser: "Update successful! Reloading page..."
}